/**
 * @Description 设置小数点
 * @date 2024/1/24
 * @param {Number} number 当前数据
 * @param {Number} digits 小数点位数
 * @return {String} 格式化小数点的字符串
 */
const setDigits = (number = 0, digits) => {
  number = Number(number);
  digits = Number(digits);

  number = Math.round(number + "e" + digits) / Math.pow(10, digits) + "";
  const s = number.split(".");
  if ((s[1] || "").length < digits) {
    s[1] = s[1] || "";
    s[1] += new Array(digits - s[1].length).fill("0").join("");
  }
  return s.join(".");
};

/**
 * 函数依赖：setDigits
 * @Description 千分位分隔符
 * 举例，10000000.16->"10,000,000.16"
 * @date 2024/2/4
 * @param {number|string} num 必传，需要转换的数字或数字字符串
 * @param {number} precision 可传，精度控制（无四舍五入）
 * 举例： 若精度未传，默认读取num本身的精度。
 * @return {string} 千分位分隔符的数字字符串
 */
const thousandSeparator = (num, precision = -1) => {
  // 最终返回值
  let returnNumStr;

  if (!isNaN(num) && num !== "") {

    // 参数precision未传入
    // 尝试从参数num取默认精度(0除外)。
    if (precision < 0) {
      if (typeof num === "string") {
        // 参数num的小数点位数
        const defaultNumPrecision = num.split(".")[1].length;
        // 小数点位数>0
        if (defaultNumPrecision) {
          // 小数点位数 赋 参数num的小数点位数
          precision = defaultNumPrecision;
        }
      }
    }

    // 类型转换
    let numToNumber = Number(num);
    // 分隔符处理
    returnNumStr = numToNumber.toLocaleString("en");

    // 参数precision已传入
    if (precision >= 0) {
      let [
        integerPart, // 整数部分
        decimalPart // 小数部分
      ] = returnNumStr.split(".");

      let paramOfSetDigits = `0`;
      if (decimalPart) {
        paramOfSetDigits = `0.${decimalPart}`;
      }
      decimalPart = setDigits(paramOfSetDigits, precision).split(".")[1];

      // 小数位数精度处理
      returnNumStr = `${integerPart}.${decimalPart}`;
    }
  } else {
    throw new Error("utils:thousandSeparator--->Input must be a number or a numeric string");
  }

  return returnNumStr;
};

const trimPlus = (str) => {
  const reg = /[\t\r\f\n\s]*/g;
  if (typeof str === "string") {
    return str.replace(reg, "");
  }
  return str;
}

const localeString = (num) =>{

  let formattedNumber = '0.00'
  if(num && !isNaN(num)){
    formattedNumber = parseFloat(num).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  return formattedNumber
}

//
const validateInput = (e) =>{
  const regex = /^\d*\.?\d*$/;
  if (!regex.test(e)) {
    e = ''
  }
  return e
}



export {
  setDigits,
  thousandSeparator,
  trimPlus,
  localeString,
  validateInput
};
